export const calendarMixin = {
    data() {
        return {
            calendarMonth: "",
            calendarYear: "",
        };
    },
    props: {
        arrDate: {
            type: Array,
            default: () => [],
        },
        logBooking: {
            type: Array,
            default: () => [],
        },
        isCalendarLoaded: {
            type: Boolean,
            default: () => true
        }
    },
    methods: {
        findEventInday(day, month, year, nameDate) {
            let listDataCalendar = [];
            let monthFormat = month.toString().length == 1 ? "0" + month.toString() : month.toString();
            let dayFormat = day.toString().length == 1 ? "0" + day.toString() : day.toString();
            let newDateFormat = `${dayFormat}-${monthFormat}-${year}`;
            // 
            for (let i = 0; i < this.logBooking.length; i++) {
                const itemBooking = this.logBooking[i];
                if (
                    itemBooking.service_datetime_start ?
                        newDateFormat === this.moment(itemBooking.service_datetime_start).format("DD-MM-YYYY")
                        :
                        newDateFormat === this.moment(itemBooking.event_datetime_start).format("DD-MM-YYYY")
                        && !['cancel'].includes(itemBooking.status)
                ) {
                    listDataCalendar.push({
                        keyID: itemBooking.id,
                        staffRequestID: itemBooking.requester_staff_detail ? itemBooking.requester_staff_detail.code : '',
                        date: newDateFormat,
                        type: "infoItemBooking",
                        content: itemBooking.name_of_event || itemBooking.detail_of_design || itemBooking.topic || itemBooking.detail_of_printing,
                        cType: "user",
                    });
                }
            }
            return listDataCalendar;
        },
        getListData(value) {
            this.isLoaded = false;
            let listData;
            listData = this.findEventInday(
                value.date(),
                Number.parseInt(value.month() + 1),
                value.year(),
                this.moment(value).format("dddd")
            )
            return listData || [];
        },
        onSelect(value) {
            this.$emit("viewBooking", this.formatDate(value._d));
        },
        headerRender({ value, type, onChange, onTypeChange }) {
            const start = 0;
            const end = 12;
            const monthOptions = [];
            const current = value.clone();
            const localeData = value.localeData();
            const months = [];
            for (let i = 0; i < 12; i++) {
                current.month(i);
                months.push(localeData.monthsShort(current));
            }
            for (let index = start; index < end; index++) {
                monthOptions.push(
                    <a-select-option class="month-item" key={`${index}`}>
                        {months[index]}
                    </a-select-option>
                );
            }
            const month = value.month();
            const year = value.year();
            const options = [];
            for (let i = year - 10; i < year + 10; i += 1) {
                options.push(
                    <a-select-option key={i} value={i} class="year-item">
                        {i}
                    </a-select-option>
                );
            }
            this.calendarMonth = value.month();
            this.calendarYear = value.year();
            return (
                <div style={{ padding: "10px" }}>
                    <a-row gutter={[8, 16]} type="flex" justify="center">
                        <a-col>
                            <a-select
                                size="small"
                                dropdownMatchSelectWidth={false}
                                value={String(month)}
                                onChange={(selectedMonth) => {
                                    const newValue = value.clone();
                                    newValue.month(Number.parseInt(selectedMonth, 10));
                                    onChange(newValue);
                                }}
                            >
                                {monthOptions}
                            </a-select>
                        </a-col>
                        <a-col>
                            <a-select
                                size="small"
                                dropdownMatchSelectWidth={false}
                                class="my-year-select"
                                onChange={(newYear) => {
                                    const now = value.clone().year(newYear);
                                    onChange(now);
                                }}
                                value={String(year)}
                            >
                                {options}
                            </a-select>
                        </a-col>
                    </a-row>
                </div>
            );
        },
        getMonthData(value) {
            if (value.month() === 8) {
                return 1394;
            }
        },
        formatDate(date) {
            let d = new Date(date),
                month = "" + (d.getMonth() + 1),
                day = "" + d.getDate(),
                year = d.getFullYear();

            if (month.length < 2) month = "0" + month;
            if (day.length < 2) day = "0" + day;

            return [year, month, day].join("-");
        },
        onPanelChange(value, mode) {
            this.$emit("sendDateTimeFormat", { a: value, b: mode });
        },
    },
};
